<div class="cnt-page-internal">
    <div class="row-title">
        <teiasoft-title [title]="'history.title' | translate"></teiasoft-title>
    </div>
    <!-- TOOLBAR -->
    <teiasoft-toolbar [buttonsList]="buttonsList" [theme]="globals.theme!" (onBtnClick)="onBtnToolbarClick($event)"
        style="width: 100%;"></teiasoft-toolbar>

    <ng-container *ngIf="initComplete">
        <!-- GRID -->
        <teiasoft-grid-odata [columnsToHideGOD]="columnsToHide" [oDataUrl]="oDataUrl" [odataEntity]="'VHistory'"
            [sortable]="true" [theme]="globals.theme!" style="width:100%" [disableAllSelection]="false"
            [filterable]="gridFilterable" [clearFilters]="clearFilters" [dateFormat]="globals.dateFormat!"
            [dateTimeFormat]="globals.dateTimeFormat!" [showSettingsDialog]="showSettingsDialog"
            (onCloseDialogSettings)="showSettingsDialog = false" (onUpdateConfiguration)="onUpdateConfiguration($event)"
            [gridConfiguration]="gridConfiguration" [autoWidth]="true" [refreshGridKey]="refreshGridKey"
            [selectable]="true" [multiSelection]="false" [paginable]="true" (rowsSelected)="rowsSelected($event)"
            [rowsPerPage]="100" [roundDigits]="roundDigitsForGrid" (onCellClick)="onCellClick($event)"
            [filtersToHide]="['NumberOfAttachments']" [headerParametersValues]="headerParametersValues"
            [customIcoCols]="customIcoCols" (customIconClick)="customIconClick($event)">
        </teiasoft-grid-odata>

        <!-- HISTORY DETAIL -->
        <div *ngIf="showHistoryDetail" class="cnt-detail" style="overflow-x: hidden !important;">
            <teiasoft-grid style="width:100%" [title]="'history-detail'" [gridName]="'historyDetail'"
                [gridDescription]="'history.titleHistoryRecords' | translate" [columnsToShow]="columnsToShowDetail"
                [dataSet]="historyRecords" [showFooter]="false" [selectable]="false" [disableAllSelection]="true"
                [theme]="globals.theme!" [autoWidth]="true" [showEditIcon]="false" 
                [dateFormat]="globals.dateFormat!" [dateTimeFormat]="globals.dateTimeFormat!" ></teiasoft-grid>

        </div>

        <!-- ITEMS -->
        <div *ngIf="showHistoryDetail" class="cnt-detail">
            <teiasoft-grid [title]="'history-items'" [gridDescription]="'history.items' | translate"
                [columnsToShow]="columnsToShowItems" [enquiryNo]="selectedEnquiryNo!" [dataSet]="dataSetItems"
                [showFooter]="false" [selectable]="false" [disableAllSelection]="true" [theme]="globals.theme!"
                [showEditIcon]="false" [dateFormat]="globals.dateFormat!" [dateTimeFormat]="globals.dateTimeFormat!"
                [calculatedCols]="calculatedCols" (onCellClick)="onCellClick($event)"
                [customRenderers]="customRenderers" [customHeaderRenderers]="customHeaderRenderers"
                style="width:100%" [enquiryHeader]="selectedEnquiryHeader"></teiasoft-grid>

        </div>
    </ng-container>
</div>

<!-- MODAL ATTACHMENTS -->
<app-modal-attach *ngIf="showAttachments" [top]="top" [itemAttachments]="itemAttachments"
    [enquiryAttachments]="enquiryAttachments" (closeAttachments)="onCloseAttachments($event)">
</app-modal-attach>

<!-- MODAL EXTRA COSTS -->
<app-modal-extra-costs *ngIf="showExtraCosts" [readOnly]="true" (onCancel)="showExtraCosts = false"
    [enquiryNo]="selectedEnquiryNo!" [enquiryHeader]="selectedEnquiryHeader!" [item]="selectedExtraCostItem!">
</app-modal-extra-costs>

<!-- MODAL DELIVERY DATES -->
<app-modal-item-delivery-dates *ngIf="showItemDeliveryDates" (onCancel)="showItemDeliveryDates = false"
    [item]="selectedDeliveryDatesItem!">
</app-modal-item-delivery-dates>

<!-- MODAL SPECIAL REQUIREMENTS -->
<app-modal-special-requirements *ngIf="showSpecialRequirements" (onClose)="showSpecialRequirements = false"
    [readOnly]="true"
    [initialCustomerSpecialRequirements]="this.customerSpecialRequirements"></app-modal-special-requirements>

<!-- ITEM CUSTOM CELLS -->
<ng-template #viewCostHeader let-column="column">
    <span>{{getCostColumnHeaderLabel(column)}}</span>
</ng-template>

<ng-template #viewCost let-row let-column="column" let-uomColumn="uomColumn">
    <div class="extra-cost-row">
        <span style="margin-right: 0.2vw;">{{row[column] && row[column].toFixed(2)}}</span>
    </div>
</ng-template>
<ng-template #viewExtraCosts let-row>
    <div class="extra-cost-row">
        <span style="margin-right: 0.2vw;">{{row.extraCosts!! && row.extraCosts.toFixed(2)}}</span>
        <div *ngIf="row.extraCosts" class="extra-cost-ico-cell"><i (click)="onItemExtraCostsClick(row)"
                class="extra-cost-icon fal fa-magnifying-glass"></i></div>
    </div>
</ng-template>
<ng-template #viewDeliveryDates let-row>
    <div class="extra-cost-row">
        <span style="margin-right: 0.1vw;">{{getItemRowMinDeliveryDate(row)}}</span>
        <span style="margin-right: 0.2vw;" *ngIf="getItemRowDeliveryDatesCollection(row).length > 1">*</span>
        <!-- <div *ngIf="getItemRowDeliveryDatesCollection(row).length > 1"
            class="extra-cost-ico-cell"><i (click)="onItemDeliveryDatesClick(row)"
                class="extra-cost-icon fal fa-magnifying-glass"></i></div> -->
    </div>
</ng-template>
